module.exports = __webpack_public_path__ + "img/FM.65078398.jpg";